import InitStopAllLogic from "./StopAll.logic";

const StopAllComponent: React.FC = () => {
    const { data, onSave, onChange } = InitStopAllLogic();
    return (
        <div className="page-container">
            <h1 className="text-align-center">Stopiraj paket svima</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                    <label htmlFor="fromDate">Od (uključen)</label>
                    <input id="fromDate" type={"date"} value={data.fromDate} onChange={onChange} name="fromDate"></input>
                </div>

                <div>
                    <label htmlFor="toDate">Do (isključen)</label>
                    <input id="toDate" type={"date"} value={data.toDate} onChange={onChange} name="toDate"></input>
                </div>

                <button className="btn-primary" type="button" onClick={onSave}>Sačuvaj</button>
            </div>
        </div>
    );
}

export default StopAllComponent;
